const calculateETA = async (startAddress, endAddress) => {
    try {
        const BingMapsAPIKey = process.env.REACT_APP_BING_MAPS_API_KEY;
        const geocodeAddress = async (address) => {
            const location = address + ' Metro Vancouver, BC'
            const geocodeResponse = await fetch(
                `https://dev.virtualearth.net/REST/v1/Locations?query=${encodeURIComponent(location)}&key=${BingMapsAPIKey}`
            );

            if (geocodeResponse.ok) {
                const geocodeData = await geocodeResponse.json();
                const location = geocodeData.resourceSets[0].resources[0].geocodePoints[0].coordinates;
                return {
                    latitude: location[0],
                    longitude: location[1],
                };
            } else {
                return null;
            }
        };

        const startCoordinates = await geocodeAddress(startAddress);
        const endCoordinates = await geocodeAddress(endAddress);

        if (startCoordinates) {
            // console.log(startCoordinates)
            const startLatLng = `${startCoordinates.latitude},${startCoordinates.longitude}`;
            const endLatLng = `${endCoordinates.latitude},${endCoordinates.longitude}`;
            const url = `https://dev.virtualearth.net/REST/v1/Routes/DistanceMatrix?origins=${startLatLng}&destinations=${endLatLng}&travelMode=driving&key=${BingMapsAPIKey}`;
            const distanceResponse = await fetch(url);
            // console.log(url)

            if (distanceResponse.ok) {
                const distanceData = await distanceResponse.json();
                const result = distanceData.resourceSets[0].resources[0];
                // const drivingDistance = result.results[0].travelDistance;
                const drivingDuration = result.results[0].travelDuration;
                return Math.round(drivingDuration);
            } else {
                return undefined;
            }
        } else {
            return undefined;
        }
    } catch (e) {
        console.log(e)
        return undefined;
    }
};


export default calculateETA;